"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _decorators = require("../../utils/propTypes/decorators");

var _UIAbstractDropdown = _interopRequireDefault(require("./UIAbstractDropdown"));

/**
 * Keeps track of the effective placement and sets arrowColor accordingly.
 */
var UIAbstractDropdownWithSearchbox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIAbstractDropdownWithSearchbox, _Component);

  function UIAbstractDropdownWithSearchbox() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIAbstractDropdownWithSearchbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIAbstractDropdownWithSearchbox)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      placement: null
    };

    _this.handleChangePlacement = function (evt) {
      var onChangePlacement = _this.props.onChangePlacement;
      var newPlacement = evt.newPlacement;

      if (_this.state.placement !== newPlacement) {
        _this.setState({
          placement: newPlacement
        });
      }

      if (onChangePlacement) onChangePlacement(evt);
    };

    return _this;
  }

  (0, _createClass2.default)(UIAbstractDropdownWithSearchbox, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // If the placement prop is reset, clear our internal override.
      if (nextProps.placement !== this.props.placement) {
        this.setState({
          placement: null
        });
      }

      if (nextProps.open && !this.props.open) {
        this.setState({
          placement: null
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          buttonUse = _this$props.buttonUse,
          dropdownClassName = _this$props.dropdownClassName,
          hasSearchbox = _this$props.hasSearchbox,
          placement = _this$props.placement,
          popoverRef = _this$props.popoverRef,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["buttonUse", "dropdownClassName", "hasSearchbox", "placement", "popoverRef"]);
      var placementState = this.state.placement;
      this.popoverRef = this.popoverRef || _react.default.createRef();
      var defaultPlacement = buttonUse.match(/link|transparent/) ? 'bottom' : 'bottom right';
      var computedPlacement = placementState || placement || defaultPlacement;
      var arrowAtBottom = computedPlacement.includes('bottom');
      var arrowAtTop = computedPlacement.includes('top');
      var computedArrowColor = hasSearchbox && arrowAtBottom ? _colors.KOALA : null;
      var computedDropdownClassName = (0, _classnames.default)(dropdownClassName, hasSearchbox && [arrowAtBottom && 'p-y-0', arrowAtTop && 'p-top-0']);
      return _react.default.createElement(_UIAbstractDropdown.default, Object.assign({}, rest, {
        arrowColor: computedArrowColor,
        buttonUse: buttonUse,
        dropdownClassName: computedDropdownClassName,
        onChangePlacement: this.handleChangePlacement,
        placement: computedPlacement,
        popoverRef: popoverRef || this.popoverRef
      }));
    }
  }]);
  return UIAbstractDropdownWithSearchbox;
}(_react.Component);

exports.default = UIAbstractDropdownWithSearchbox;
UIAbstractDropdownWithSearchbox.propTypes = Object.assign({}, _UIAbstractDropdown.default.propTypes, {
  arrowColor: (0, _decorators.hidden)(_UIAbstractDropdown.default.propTypes.arrowColor),
  hasSearchbox: _propTypes.default.bool.isRequired
});
UIAbstractDropdownWithSearchbox.defaultProps = _UIAbstractDropdown.default.defaultProps;
UIAbstractDropdownWithSearchbox.displayName = 'UIAbstractDropdownWithSearchbox';
module.exports = exports.default;